import React, { useState } from 'react'
import styled from "styled-components";
import { ThemeProps } from '../../genericComponents/globalStyles';
import { Button } from "../../genericComponents";
import CreditCardCheckoutForm from '../../payments/components/CreditCardCheckoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

export default function RetryStripeSubscriptionPayment({stripeSubscription }) {
  const [showRetryForm, setShowRetryForm] = useState(false)
  return (
    <Container>
      <SubContainer>
      <Title>Your last payment failed</Title>
      <Button onClick={() => setShowRetryForm(true)}>Retry</Button>
      <Elements stripe={stripePromise} >
        {showRetryForm&&(
          <FormContainer>
            <CreditCardCheckoutForm
              setShowCheckout={setShowRetryForm}
              showCheckout={showRetryForm}
              cancelClick={() => setShowRetryForm(false)}
              stripeSubscription={stripeSubscription}
              retryPayment={true}
            />
          </FormContainer>
        )}
      </Elements>
      </SubContainer>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
`;
const FormContainer = styled.div`
  margin-top: 32px;
  border-radius: 8px;
  background-color: ${ThemeProps.color.softYellow};
`;
const Title = styled.h2`
  color: ${ThemeProps.color.darkBlue};
`;